import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  alpha,
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import { FC } from "react";
import { RouteDefinition } from "src/routes/Routes";

type SidebarSectionProps = {
  icon?: React.ReactElement;
  name: string;
  listItens: RouteDefinition[];
};

const SidebarSection: FC<SidebarSectionProps> = (props): JSX.Element => {
  const theme = useTheme();
  const hoverBg = alpha(theme.palette.primary.main, 0.12);

  return (
    <Box>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          sx={{ "&:hover": { backgroundColor: hoverBg } }}
        >
          <Box sx={{ display: "flex", flexFlow: "row", alignItems: "center", gap: "1rem" }}>
            {Boolean(props?.icon) && <>{props.icon}</>}
            <Typography>{props.name}</Typography>
          </Box>
        </AccordionSummary>
        <Divider />
        <AccordionDetails>
          <List disablePadding>
            {props.listItens?.filter(r => !r.hideFromMenu)?.map((route, index) => {
              if ((route?.innerRoutes ?? []).length > 0) {
                return (
                  <Accordion key={index} elevation={0}>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      sx={{ "&:hover": { backgroundColor: hoverBg, borderRadius: 2 } }}
                    >
                      <Box sx={{ display: "flex", flexFlow: "row", alignItems: "center", gap: "1rem" }}>
                        <Typography>{route?.name}</Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      <List disablePadding>
                        {route?.innerRoutes?.filter(r => !r.hideFromMenu)?.map((r) => (
                          <ListItemButton
                            key={r.path}
                            LinkComponent="a"
                            href={r.path ?? "/"}
                            sx={{ "&:hover": { backgroundColor: hoverBg, borderRadius: 2 } }}
                          >
                            <ListItemText primary={r.name} />
                          </ListItemButton>
                        ))}
                      </List>
                    </AccordionDetails>
                  </Accordion>
                );
              }

              return (
                <ListItemButton
                  key={index}
                  LinkComponent="a"
                  href={route.path ?? "/"}
                  sx={{ "&:hover": { backgroundColor: hoverBg, borderRadius: 2 } }}
                >
                  <ListItemText primary={route.name} />
                </ListItemButton>
              );
            })}
          </List>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default SidebarSection;
